// The in-app message sound (Settings, Message sound): a short two-note chime when a customer
// writes while the app is open. Alerts with the app closed use the phone's own sound.
// Remembered on this device; on unless switched off.

const KEY = 'chats.sound';

export function readSound(): boolean {
  try { return localStorage.getItem(KEY) !== '0'; } catch { return true; }
}

export function writeSound(on: boolean): void {
  try { localStorage.setItem(KEY, on ? '1' : '0'); } catch { /* storage blocked: holds for this visit */ }
}

let audio: AudioContext | null = null;
let lastChime = 0;

export function playChime(): void {
  if (!readSound() || document.visibilityState !== 'visible') return;
  // A new message can ring twice, from the chat list and from the in-page alert (17 Oct): once is enough.
  if (Date.now() - lastChime < 3000) return;
  lastChime = Date.now();
  try {
    audio ??= new AudioContext();
    const ctx = audio;
    [880, 1320].forEach((freq, i) => {
      const at = ctx.currentTime + i * 0.12;
      const osc = ctx.createOscillator();
      const gain = ctx.createGain();
      osc.frequency.value = freq;
      gain.gain.setValueAtTime(0.0001, at);
      gain.gain.exponentialRampToValueAtTime(0.18, at + 0.02);
      gain.gain.exponentialRampToValueAtTime(0.0001, at + 0.25);
      osc.connect(gain).connect(ctx.destination);
      osc.start(at);
      osc.stop(at + 0.26);
    });
  } catch {
    // No sound on this device: the unread count still shows.
  }
}
